import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const CartItemSchema = z.object({
  slug: z.string(),
  bundleQty: z.number().int().min(1).max(1000),
  qty: z.number().int().min(1).max(100),
});

export const createCheckout = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      items: z.array(CartItemSchema).min(1).max(20),
      countryCode: z.string().length(2),
      cartToken: z.string().nullable().optional(),
      couponCode: z.string().nullable().optional(),
      affiliateCode: z.string().nullable().optional(),
    }).parse,
  )
  .handler(async ({ data }) => {
    const { createCheckoutServer } = await import("./checkout.server");
    return createCheckoutServer(data);
  });

export const getOrderByCheckout = createServerFn({ method: "GET" })
  .inputValidator(z.object({ checkoutId: z.string().uuid() }).parse)
  .handler(async ({ data }) => {
    const { getOrderByCheckoutServer } = await import("./checkout.server");
    return getOrderByCheckoutServer(data);
  });

// Attach the caller's Supabase user to a paid order created via guest checkout.
// Email must match the order's customer email. Idempotent if already claimed
// by the same user.
export const claimOrderByCheckout = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator(z.object({ checkoutId: z.string().uuid() }).parse)
  .handler(async ({ data, context }) => {
    const { claimOrderByCheckoutServer } = await import("./checkout.server");
    return claimOrderByCheckoutServer({
      checkoutId: data.checkoutId,
      userId: context.userId,
      email: (context.claims?.email as string | undefined) ?? null,
    });
  });
